import React from "react";
import { Link } from "react-router-dom";

const ProfilesGrid = ({ profiles }) => {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-5xl mx-auto px-6">
                <h2 className="text-3xl font-bold text-brand-blue mb-4 text-center">Reformista se adapta a ti</h2>
                <p className="text-center text-gray-500 text-lg max-w-2xl mx-auto mb-12">
                    Cada perfil tiene necesidades distintas. Elige el tuyo y descubre cómo te ayudamos.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {profiles.map((profile, i) => (
                        <Link
                            key={i}
                            to={profile.url}
                            className="block bg-white shadow rounded-lg p-6 border border-gray-200 hover:shadow-lg transition-shadow no-underline"
                        >
                            <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl mb-4 ${profile.colorClass || "bg-blue-50"}`}>
                                {profile.icon}
                            </div>
                            <h3 className="font-bold text-gray-900 text-lg mb-1">{profile.name}</h3>
                            <p className="text-brand-blue text-sm font-medium mb-3">{profile.tagline}</p>
                            <p className="text-gray-500 text-sm mb-4">{profile.description}</p>
                            {profile.problems && profile.problems.length > 0 && (
                                <ul className="mb-4 space-y-1">
                                    {profile.problems.map((prob, j) => (
                                        <li key={j} className="text-xs text-gray-400 flex items-start gap-1">
                                            <span className="mt-0.5">•</span> {prob}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <span className="text-brand-blue text-sm font-semibold">Descubre cómo →</span>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProfilesGrid;
